/**
 * Bloco 3 — Rate limiter e sampling.
 * Mouse: throttle 100ms, só contador. Keypress: só contador (não capturar conteúdo).
 * Incrementos marcam dirty para o heartbeat.
 */

import { setBehaviorDirty } from './dirty';

const MOUSE_THROTTLE_MS = 100;

let mouseMovementCount = 0;
let keypressCount = 0;
let lastMouseTick = 0;
let mouseThrottleTimer: ReturnType<typeof setTimeout> | null = null;

function onMouseMove(): void {
  const now = Date.now();
  if (now - lastMouseTick >= MOUSE_THROTTLE_MS) {
    lastMouseTick = now;
    mouseMovementCount += 1;
    setBehaviorDirty();
  } else if (mouseThrottleTimer === null) {
    mouseThrottleTimer = setTimeout(
      () => {
        mouseThrottleTimer = null;
        lastMouseTick = Date.now();
        mouseMovementCount += 1;
        setBehaviorDirty();
      },
      MOUSE_THROTTLE_MS - (now - lastMouseTick)
    );
  }
}

function onKeypress(): void {
  keypressCount += 1;
  setBehaviorDirty();
}

let mouseAttached = false;
let keypressAttached = false;

export function initBehaviorRateLimit(): void {
  if (typeof window === 'undefined') return;
  if (!mouseAttached) {
    mouseAttached = true;
    window.addEventListener('mousemove', onMouseMove, { passive: true });
  }
  if (!keypressAttached) {
    keypressAttached = true;
    window.addEventListener('keydown', onKeypress, { passive: true });
  }
}

export function getMouseMovementCount(): number {
  return mouseMovementCount;
}

export function getKeypressCount(): number {
  return keypressCount;
}

export function resetBehaviorRateLimitCounts(): void {
  mouseMovementCount = 0;
  keypressCount = 0;
}

export function destroyBehaviorRateLimit(): void {
  if (mouseThrottleTimer) {
    clearTimeout(mouseThrottleTimer);
    mouseThrottleTimer = null;
  }
  if (typeof window === 'undefined') return;
  if (mouseAttached) {
    mouseAttached = false;
    window.removeEventListener('mousemove', onMouseMove);
  }
  if (keypressAttached) {
    keypressAttached = false;
    window.removeEventListener('keydown', onKeypress);
  }
  mouseMovementCount = 0;
  keypressCount = 0;
}
